"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResultCountMessage = void 0;
var Localization_1 = require("../Localization");
var getResultCountMessage = function (resultcount) {
    if (resultcount === 0) {
        return Localization_1.strings.Search_Label_NoResultsFound;
    }
    else if (resultcount === 1) {
        return Localization_1.strings.Search_Label_OneResultFound;
    }
    else {
        return resultcount + Localization_1.strings.Search_Label_MoreResultsFound;
    }
};
exports.getResultCountMessage = getResultCountMessage;
